import {
  Arrange,
  Container,
  Icon,
  IconButton,
  SvgClose,
  SvgPresent,
  Text,
} from '@loomhq/lens';
import React from 'react';

import styles from './styles.module.less';

function CloseButton({ handleClick }): JSX.Element {
  return (
    <IconButton
      altText="close"
      icon={<SvgClose />}
      size="small"
      onClick={handleClick}
    />
  );
}

interface EarnMoreVideosPromptProps {
  handleClick: (e: any) => void;
  handleClose: (e: any) => void;
}

function EarnMoreVideosPrompt({
  handleClick,
  handleClose,
}: EarnMoreVideosPromptProps): JSX.Element {
  function close(e: any) {
    e.stopPropagation();

    handleClose(e);
  }

  return (
    <div onClick={handleClick} className={styles.clickableContainer}>
      <Container
        color="grey8"
        backgroundColor="hsla(180, 51%, 52%, 0.18)"
        radius="medium"
        paddingY="xsmall"
        paddingX="0.75rem"
      >
        <Arrange gap="small">
          <Icon size="1.25rem" icon={<SvgPresent />} />
          <Text size="medium" fontWeight="medium">
            Earn free videos
          </Text>
          <CloseButton handleClick={close} />
        </Arrange>
      </Container>
    </div>
  );
}

export default EarnMoreVideosPrompt;
